import { SERVER_DOMAIN } from "../config/config.js";

let sentryLogger = null;

export const initLogger = () => {
  import("@sentry/react")
    .then(({ init, logger }) => {
      init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: SERVER_DOMAIN,
        enableLogs: true,
      });
      sentryLogger = logger;
    })
    .catch(() => {
      // Sentry is optional for local/preview boots without a DSN/network.
    });
};

export const logError = ({ message, context = {} }) => {
  if (!sentryLogger) return;
  sentryLogger.error(message, context);
};
